import PropTypes from "prop-types"
import React from "react"
import GooglePlacesSearchInput from "./GooglePlacesSearchInput"

const StoreSearchStep = ({ onPlaceSelected, onManualEntry }) => (
  <section className="partner-page partner-search-step">
    <div className="partner-search-copy">
      <span className="partner-eyebrow">Lancez votre espace partenaire</span>
      <h1>Vos invendus méritent une nouvelle chance.</h1>
      <p className="partner-lead">
        Rejoignez Wevalo, publiez vos paniers et transformez simplement vos surplus en nouvelles opportunités.
      </p>
    </div>
    <div className="partner-search-discovery">
      <div className="partner-search-discovery-icon"><i className="bx bx-map-pin" /></div>
      <h2>Retrouvez votre commerce</h2>
      <p>Nous préremplirons automatiquement son adresse et sa localisation.</p>
      <div className="partner-search-box">
        <label>Nom du commerce, adresse ou ville</label>
        <GooglePlacesSearchInput onPlaceSelected={onPlaceSelected} />
        <p><i className="bx bx-search-alt" /> Sélectionnez votre établissement dans les résultats.</p>
      </div>
      <div className="partner-manual-entry">
        <span>Votre commerce n’apparaît pas ?</span>
        <button type="button" className="partner-button partner-button-secondary" onClick={onManualEntry}>
          <i className="bx bx-edit" /> Le renseigner manuellement
        </button>
      </div>
    </div>
  </section>
)

StoreSearchStep.propTypes = {
  onManualEntry: PropTypes.func.isRequired,
  onPlaceSelected: PropTypes.func.isRequired,
}

export default StoreSearchStep
